import WebTracing, {
  InitOptions,
  intersectionObserver,
  intersectionUnobserve,
} from '@web-tracing/vue3';
import useUserStore from '@/store/modules/user';

import pvFix from './fixFunc/pvFix.js';
import clickFix from './fixFunc/clickFix.js';
import intersectionFix from './fixFunc/intersectionFix.js';

const fixFuncEventTypeMap = {
  pv: pvFix,
  custom: clickFix,
  click: clickFix,
  intersection: intersectionFix,
};

const fixFinalData = (data) => {
  data.baseInfo.appCode = data.baseInfo.appName;
  data.baseInfo.userUuid = useUserStore().userId;
  delete data.baseInfo.appName;
  data.eventInfo.forEach((e) => {
    delete e._finalAdd;
  });
  const res = data.eventInfo.map((e) => ({
    userId: useUserStore().userId,
    // 1：页面访问，2：按钮点击）
    type: e.eventType === 'pv' ? '1' : '2',
    resourceCode: e.eventId,
    resourceId: e.custom,
    platform: import.meta.env.VITE_APP_WEB_TRACING_PLATFORM,
  }));
  return res;
};

const arrowEventType = ['pv', 'click', 'intersection', 'custom'];
const initWebTracing = (app) => {
  app.use(WebTracing, {
    dsn:
      import.meta.env.VITE_APP_BASE_API +
      import.meta.env.VITE_APP_WEB_TRACING_DSN,
    // dsn: 'http://localhost:3351/trackweb',
    appName: 'data-space',
    debug: import.meta.env.VITE_APP_ENV === 'development',
    pv: true,
    performance: {
      core: false,
      firstResource: false,
      server: false,
    },
    error: false,
    event: true,
    // localization: true,
    cacheMaxLength: 5,
    cacheWatingTime: 2000,
    userUuid: '',
    sendTypeByXmlBody: true,
    recordScreen: false,

    scopeError: true,

    // tracesSampleRate: 0.5,

    ignoreRequest: [],
    // 关闭自动重试的ping请求
    checkRecoverInterval: -1,

    beforePushEventList(data) {
      // data 是一个数组，格式：[{}]
      const newData = data
        .filter((item) => arrowEventType.includes(item.eventType))
        .map((item) => {
          if (fixFuncEventTypeMap[item.eventType]) {
            fixFuncEventTypeMap[item.eventType](item);
          }
          if (!item.custom) {
            item.custom = '';
          }
          return item;
        })
        .filter((item) => !!item._finalAdd);
      return newData;
    },
    beforeSendData(data) {
      return fixFinalData(data);
    },
    // afterSendData(data) {
    // },
  } as InitOptions);
};

export const startWebTracingObserve = (target, params = {}) => {
  intersectionObserver({
    target,
    threshold: 0.5, // 曝光的临界点 (0.5表示移入窗口一半算做开始曝光、移出窗口一半算结束曝光)
    params,
  });
};

export const stopWebTracingObserve = (target) => {
  intersectionUnobserve(target);
};

export default initWebTracing;
